"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSearch = updateSearch;
exports.getUrlParams = getUrlParams;
exports.stateToUrl = exports.urlToState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _queryString = _interopRequireDefault(require("query-string"));

var R = _interopRequireWildcard(require("ramda"));

var _utils = require("@alycecom/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var urlToState = (0, _utils.renameKeys)({
  search: 'search',
  sort: 'sort',
  team_id: 'teamId',
  gift_id: 'giftId',
  date_range_from: 'dateRangeFrom',
  date_range_to: 'dateRangeTo',
  teams_search: 'teamsSearch',
  teams_sort: 'teamsSort',
  teams_direction: 'teamsDirection',
  team_members_page: 'teamMembersPage',
  team_members_search: 'teamMembersSearch',
  team_members_sort: 'teamMembersSort',
  team_members_direction: 'teamMembersDirection',
  gift_sort: 'giftSort',
  gift_direction: 'giftDirection',
  gift_search: 'giftSearch',
  gift_page: 'giftPage',
  campaigns_search: 'campaignsSearch',
  campaigns_sort: 'campaignsSort',
  campaigns_direction: 'campaignsDirection',
  campaigns_page: 'campaignsPage',
  contacts_search: 'contactsSearch',
  contacts_sort: 'contactsSort',
  contacts_direction: 'contactsDirection',
  contacts_page: 'contactsPage',
  billing_search: 'billingSearch',
  billing_sort: 'billingSort',
  billing_direction: 'billingDirection',
  contact_id: 'contactId',
  sidebar_tab: 'sidebarTab',
  per_page: 'perPage',
  sort_column: 'sortColumn',
  sort_direction: 'sortDirection',
  templates_search: 'templatesSearch',
  include_archived: 'includeArchived'
});
exports.urlToState = urlToState;
var stateToUrl = (0, _utils.renameKeys)({
  search: 'search',
  sort: 'sort',
  teamId: 'team_id',
  giftId: 'gift_id',
  campaignsSearch: 'campaigns_search',
  campaignsSort: 'campaigns_sort',
  campaignsDirection: 'campaigns_direction',
  campaignsPage: 'campaigns_page',
  dateRangeFrom: 'date_range_from',
  dateRangeTo: 'date_range_to',
  teamsSearch: 'teams_search',
  teamsSort: 'teams_sort',
  teamsDirection: 'teams_direction',
  teamMembersPage: 'team_members_page',
  teamMembersSearch: 'team_members_search',
  teamMembersSort: 'team_members_sort',
  teamMembersDirection: 'team_members_direction',
  giftSort: 'gift_sort',
  giftDirection: 'gift_direction',
  giftSearch: 'gift_search',
  giftPage: 'gift_page',
  contactsSearch: 'contacts_search',
  perPage: 'per_page',
  contactsSort: 'contacts_sort',
  contactsDirection: 'contacts_direction',
  contactsPage: 'contacts_page',
  billingSearch: 'billing_search',
  billingSort: 'billing_sort',
  billingDirection: 'billing_direction',
  contactId: 'contact_id',
  sidebarTab: 'sidebar_tab',
  sortColumn: 'sort_column',
  sortDirection: 'sort_direction',
  templatesSearch: 'templates_search',
  includeArchived: 'include_archived'
});
exports.stateToUrl = stateToUrl;

function updateSearch(search, updateObj) {
  var searchObj = urlToState(_queryString.default.parse(search));

  var newSearchObj = _objectSpread(_objectSpread({}, searchObj), updateObj);

  return _queryString.default.stringify(R.compose(stateToUrl, R.pickBy(R.identity))(newSearchObj));
}

function getUrlParams(search) {
  return urlToState(_queryString.default.parse(search));
}